import React, { useEffect } from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css";

function SecurityTesting() {
     useEffect(()=>{
      AOS.init({duration:1000 , once:true})
     },[])

    return (
        <div className="webdev-page" style={{overflowX:"hidden"}}>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Security Testing </h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Introduction Section */}
            <section className="security-intro-section">
                <div className="container">
                <div className="section-header">
                        <h2 data-aos="fade-up">Protect Your Software from Security Threats</h2>
                        <p className="section-description">
                        We provide end-to-end security testing services to safeguard your software from vulnerabilities and breaches. Our security experts identify and mitigate potential risks to protect sensitive data, ensure compliance, and maintain application integrity.                        </p>
                    </div>

                </div>
            </section>

            {/* Our Services Section */}
            <section className="webdev-services-section">
                <div className="container">
                    <div className="section-header">
                        <h2 data-aos="fade-up">Our Security Testing Services</h2>
                        <p className="section-description">
                            Comprehensive security assessment solutions to protect your applications from threats
                        </p>
                    </div>

                    <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-code"></i>
                            </div>
                            <h3>Security Code Review</h3>
                            <p>Thorough review of source code to detect insecure coding practices and identify risks in third-party libraries.</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-user-secret"></i>
                            </div>
                            <h3>Penetration Testing</h3>
                            <p> Simulated cyberattacks to uncover real-world vulnerabilities and assess system resilience..</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-search"></i>
                            </div>
                            <h3>Vulnerability Assessment</h3>
                            <p>Comprehensive scans to detect security weaknesses and strengthen your application’s defenses.</p>
                        </div>
                        
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-network-wired"></i>
                            </div>
                            <h3>API Security Testing</h3>
                            <p>Rigorous evaluation of API endpoints for authentication, authorization, and data handling vulnerabilities.</p>
                        </div>
                        
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <h3>Mobile App Security</h3>
                            <p>In-depth assessment of mobile apps to identify platform-specific risks and ensure safe data storage.</p>
                        </div>
                        
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-cloud"></i>
                            </div>
                            <h3>Cloud Security Assessment</h3>
                            <p>Detailed analysis of cloud infrastructure configurations to ensure security best practices and compliance.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Security Testing Process Section */}
            <section className="design-process-section security-process-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our Security Testing Process</h2>
                        <p className="section-description">
                            A structured approach to ensuring the security and integrity of your software applications
                        </p>
                    </div>

                    <div className="process-timeline">
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Requirement Analysis & Planning</h3>
                                <p>Tailored security strategy based on your application architecture and business needs.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>Vulnerability Scanning</h3>
                                <p>Automated scans to identify potential risks and weak points.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>Penetration Testing</h3>
                                <p>Realistic attack simulations to uncover exploitable vulnerabilities.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>Security Code Review</h3>
                                <p>Manual source code inspection to detect unsafe coding patterns and library vulnerabilities.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>Reporting & Recommendations</h3>
                                <p>Actionable reports with detailed vulnerability insights and remediation strategies.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">6</div>
                            <div className="step-content">
                                <h3>Ongoing Support & Validation</h3>
                                <p>Continuous monitoring and validation to ensure ongoing compliance and security.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Key Features Section */}
            

            <section className="design-principles-section">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our Designs</h2>
            <p className="section-description">
              Our design philosophy is built on principles that ensure exceptional user experiences
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" ddata-aos-delay="300">
            {[
              
                {
                  icon: "fas fa-user-shield", 
                  title: "User-Centered Design", 
                  text: "Full-spectrum security testing, from code to cloud."
                },
                {
                  icon: "fas fa-balance-scale", 
                  title: "Compliance-Driven Approach", 
                  text: "Align with HIPAA, GDPR, PCI-DSS, and other regulatory standards."
                },
                {
                  icon: "fas fa-shield-alt", 
                  title: "Proactive Risk Mitigation", 
                  text: "Identify and resolve security gaps before they’re exploited."
                },
                {
                  icon: "fas fa-tools", 
                  title: "Industry-Leading Tools", 
                  text: "Leverage cutting-edge tools and methodologies to stay ahead of threats."
                },
                {
                  icon: "fas fa-headset", 
                  title: "Ongoing Security Support", 
                  text: "Continuous monitoring and re-assessments to maintain protection."
                },
                {
                  icon: "fas fa-layer-group", 
                  title: "Scalable Solutions", 
                  text: "Security testing designed to grow with your product and infrastructure."
                }
              
              
            ].map((feature, idx) => (
              <div className="service-card" key={idx}>
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

            {/* CTA Section */}
            <section className="cta-section mt-5 security-cta">
                <div className="container">
                    <div className="cta-content">
                        <h2>Secure Your Software Applications Today</h2>
                        <p>Let our security experts help you identify and address vulnerabilities before they become threats.</p>
                        <a href="/contact" className="cta-button">Get a Free Security Assessment</a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default SecurityTesting;
